jQuery( '.gallery-slider.alongside-text' ).slick( {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    rows: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    pauseOnFocus: true,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                rows: 1,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                rows: 1,
            }
        },
    ]
} );